import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import CardText from "../../CardText";

export function ConsumerContactInfoError() {
  const tailwind = useTailwind();
  return (
    <View>
      <CardText.Subtitle text="Contacto" style={tailwind("mb-1")} />
      <CardText.Body
        text="Tu cliente no ha ingresado sus datos de contacto."
        error
      />
    </View>
  );
}
